var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"short-risk"},[_c('div',{staticClass:"risk-list"},[_c('div',{staticClass:"risk-item"},[_c('span',[_vm._v("要素/时间")]),_vm._l((_vm.riskShort.times),function(item,index){return _c('span',{key:index + ''},[_vm._v(_vm._s(item))])})],2),_vm._l((_vm.riskShort.data),function(item,key){return _c('div',{key:key,staticClass:"risk-item"},[_c('span',[_vm._v(_vm._s(key))]),_vm._l((_vm.riskShort.times.length),function(index1){return _c('span',{key:index1 + ''},[_c('i',{style:({
              background:
                item[index1 - 1] == 1
                  ? 'red'
                  : item[index1 - 1] == 2
                    ? 'orange'
                    : item[index1 - 1] == 3
                      ? '#ffd90a'
                      : item[index1 - 1] == 4
                        ? 'blue'
                        : item[index1 - 1] == 5
                          ? '#FFF'
                          : '',
            })},[_c('i',{staticClass:"pounp"},[_vm._v(_vm._s(_vm.riskShort.data[key][index1 - 1] ? _vm.riskShort.data[key][index1 - 1] : "--"))])])])})],2)})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }